// Copyright (c) Move Closer 2022.

import { Description, IRelatedService, Related, SearchGroup } from '../../../../contexts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const searchResultProductResolver = async (
  group: string,
  payload: Related,
  relatedService: IRelatedService
): Promise<SearchGroup> => {
  let elements: SearchGroup['elements'] = []
  let description: Description

  try {
    elements = await relatedService.resolve(payload)
  } catch (e) {
    throw new Error((e as Error).message)
  }

  try {
    description = await relatedService.describe(payload)
  } catch (e) {
    throw new Error((e as Error).message)
  }

  return {
    group,
    elements,
    totalCount: description.totalItems
  }
}
